import type { IQueueDurationSpineAudit } from '@/helpers/playerDiagnostics/queueDurationSpine'
import type { IQueueFrame } from '@/types'
import {
  setPlayerDiagnosticFaultActive
} from '@/helpers/playerDiagnostics/playerDiagnosticService'
import { isPlayerDiagnosticsSamplingEnabled } from '@/helpers/playerDiagnostics/playerDiagnosticsKillSwitch'
import {
  detectQueueDurationSpineMismatch

} from '@/helpers/playerDiagnostics/queueDurationSpine'
import { getQueueSequenceHash } from '@/helpers/queueHash'
import { clearPlayerPlaybackDurationInvariantSentryDedupe, reportPlayerPlaybackDurationInvariantToSentry } from '@/helpers/reportPlayerPlaybackDurationInvariantToSentry'

export interface IObserveQueueDurationSpineInvariantInput {
  audit: IQueueDurationSpineAudit | null | undefined
  materializedQueue: readonly IQueueFrame[]
  scheduleRootUrn?: string | null
  operatorMasterPlaylistUrn?: string | null
  nowMs?: number
}

let lastSpineMismatchActive = false

export function observeQueueDurationSpineInvariant(input: IObserveQueueDurationSpineInvariantInput): void {
  const status = detectQueueDurationSpineMismatch(input.audit)
  const nowMs = input.nowMs ?? Date.now()
  const queueSequenceHash = input.materializedQueue.length > 0
    ? getQueueSequenceHash([...input.materializedQueue])
    : null

  if (status.suspected) {
    const detailMs = Math.max(
      0,
      Math.round((status.publishedDurationSec - status.materializedDurationSec) * 1000)
    )
    reportPlayerPlaybackDurationInvariantToSentry({
      code: 'queue_duration_spine_mismatch',
      detailMs,
      frameId: status.frameId,
      frameIndex: status.frameIndex,
      reason: status.reason,
      publishedDurationSec: status.publishedDurationSec,
      materializedDurationSec: status.materializedDurationSec,
      publishedCampaignTotalSec: status.publishedCampaignTotalSec,
      materializedCampaignTotalSec: status.materializedCampaignTotalSec,
      queueSequenceHash,
      scheduleRootUrn: input.scheduleRootUrn ?? null,
      operatorMasterPlaylistUrn: input.operatorMasterPlaylistUrn ?? null
    })
    if (isPlayerDiagnosticsSamplingEnabled(nowMs)) {
      setPlayerDiagnosticFaultActive('queue_duration_spine_mismatch', true, nowMs, detailMs)
    }
    lastSpineMismatchActive = true
    return
  }

  if (lastSpineMismatchActive) {
    if (isPlayerDiagnosticsSamplingEnabled(nowMs)) {
      setPlayerDiagnosticFaultActive('queue_duration_spine_mismatch', false, nowMs, 0)
    }
    clearPlayerPlaybackDurationInvariantSentryDedupe('queue_duration_spine_mismatch')
    lastSpineMismatchActive = false
  }
}

/** Test-only reset of latched spine mismatch state. */
export function resetQueueDurationSpineInvariantStateForTests(): void {
  lastSpineMismatchActive = false
}
